import { invoiceStatusConfig } from 'entities';

import { UploadInvoice } from './UploadInvoice';
import { ConfirmPayment } from './ConfirmPayment';
import { SendToAccountant } from './SendToAccountant';
import { CancelationRequested } from './CancelationRequested';

import { InvoiceTabProps } from './types';

export const statusToAction: Record<string, typeof UploadInvoice> = {
  [invoiceStatusConfig.sentToAccountant.code]: UploadInvoice,
  [invoiceStatusConfig.invoiced.code]: ConfirmPayment,
  [invoiceStatusConfig.readyToSendToAccountant.code]: SendToAccountant,
};

export function InvoiceAction({ invoice, ...props }: InvoiceTabProps): JSX.Element {
  const Action = statusToAction[invoice.status];

  if (invoice.cancelationRequestId) return <CancelationRequested />;

  return (
    Action && (
      <div className="rounded-md border p-4">
        <Action invoice={invoice} {...props} />
      </div>
    )
  );
}
